import { useEffect, useState } from 'react';
import { s3BucketInstance } from '../services/api';

export default function useFooter() {
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const getFooterData = async () => {
      try {
        setLoading(true);
        const res = await s3BucketInstance.get('/json-files/footer.json');
        setFooterData(res);
      } catch (err) {
        setError(true);
        setFooterData(null);
      } finally {
        setLoading(false);
      }
    };

    getFooterData();
  }, []);

  return { footerData, loading, error };
}
